import React, { useState } from 'react';
import './App.css'; // Import the CSS file for styling
import Banner from './Banner.js';
import Home from './Home.js';
import ModelGenerator from './ModelGenerator';

const App = () => {
  const [currentPage, setCurrentPage] = useState('home');
  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return <Home />;
      case 'model-generator':
        return <ModelGenerator />;
      default:
        return null;
    }
  };
  
  return (
      <div className="app-container">
      <Banner
        onHomeClick={() => setCurrentPage('home')}
        onModelGeneratorClick={() => setCurrentPage('model-generator')}
      />
      <div className="content-container">{renderPage()}</div>
      </div>
  );
};

export default App;
